export enum EOrderStatusChangeStatus {
    None,
    Saving,
    Error,
    Success
}

export interface IOrderItemsGroup {
    concat: string;
    make: string;
    model: string;
    fromYear: number;
    toYear: number;
    selectedYear: number | null;
    items: IOrderItem[];
    vin: string | null;
}

export interface IOrderItem {
    make: string;
    model: string;
    fromYear: number;
    toYear: number;
    image: string;
    id: number;
    itemcode: string;
    customerItemcode: string;
    itemname: string;
    oem?: string;
    partsLink?: string;
    dpi?: string;
    certification?: string;
    quantity?: number | null;
    price?: number | null;
}

export interface IOrderHistory {
    id: number;
    cardcode: string;
    cardname: string;
    poNumber: string | null;
    cartId: number;
    total: number;
    orderItemCount: number;
    status: number;
    statusName: string;
    itemsLoading: boolean;
    itemsExpanded: boolean;
    itemsEntries: IOrderItem[];
    createdAt: string;
    updatedAt: string;
}

export interface IOrderOverview {
    id: number;
    cardcode: string;
    cardname: string;
    customerEmail: string | null;
    poNumber: string | null;
    cartId: number;
    total: number;
    orderItemCount: number;
    shippingMethodId: number;
    shippingMethodOtherId: number | null;
    shippingMethodOtherAccountId: string | null;
    shippingMethodOtherInstructions: string | null;
    shippingMethodOtherTime: string | null;
    shippingAddress: string;
    shippingAddressId: number;
    whscode: string | null;
    status: 1 | 2 | 3;
    statusName: string;
    inSap: boolean | null;
    createdByUserId: number;
    createdAt: string;
    updatedAt: string;
}

export interface IOrderListApiResponse {
    data: IOrderOverview[];
    limit: number;
    skip: number;
    total: number;
}

export interface IOrderGetItem {
    id: number;
    itemId: number;
    itemCode: string;
    custItemCode: string | null;
    itemName: string;
    make: string;
    model: string;
    fromYear: number;
    toYear: number;
    dpi: string | null;
    oem1: string | null;
    oem2: string | null;
    partsLink1: string | null;
    partsLink2: string | null;
    certification: string | null;
    image: string | null;
    imageThumb: string | null;
    orderId: number;
    price: string;
    quantity: number;
    selectedYear: number | null;
    total: string;
}

export interface IOrderGetApiResponse {
    items: IOrderGetItem[];
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/order.ts